import { Navigate, type RouteObject } from 'react-router';
import { recordTabRoutes } from '../../shared/components/record-tab-routes';
import { MovedAddIntegrationRedirect } from './components/MovedAddIntegrationRedirect';
import { MovedGpsIntegrationRedirect } from './components/MovedGpsIntegrationRedirect';
import { GPS_INTEGRATION_TABS } from './features/gps/gps.paths';
import { GpsIntegrationPage } from './features/gps/pages/GpsIntegrationPage';
import { addIntegrationPath, INTEGRATION_KINDS, integrationTabPath } from './integrations.paths';
import { IntegrationsPage } from './pages/IntegrationsPage';

/**
 * A tab per kind; its sheets render the same page, so React keeps it mounted while they open and close. A GPS
 * integration is a record with its own tabs. Older URLs (the single page, catalogue, installed, device mappings) redirect.
 */
export const INTEGRATION_ROUTES: RouteObject[] = [
  { path: 'integrations', element: <Navigate to={integrationTabPath(INTEGRATION_KINDS[0])} replace /> },
  ...INTEGRATION_KINDS.flatMap((kind) => [
    { path: `integrations/${kind}`, element: <IntegrationsPage tab={kind} /> },
    { path: `integrations/${kind}/add`, element: <IntegrationsPage tab={kind} sheet="add" /> },
  ]),
  { path: 'integrations/sms/new', element: <IntegrationsPage tab="sms" sheet="sms-install" /> },
  { path: 'integrations/sms/:id', element: <IntegrationsPage tab="sms" sheet="sms-settings" /> },
  { path: 'integrations/whatsapp/new', element: <IntegrationsPage tab="whatsapp" sheet="whatsapp-install" /> },
  { path: 'integrations/whatsapp/:id', element: <IntegrationsPage tab="whatsapp" sheet="whatsapp-settings" /> },
  { path: 'integrations/gps/new', element: <IntegrationsPage tab="gps" sheet="gps-install" /> },
  ...recordTabRoutes('integrations/gps/:id', GPS_INTEGRATION_TABS, (tab) => <GpsIntegrationPage tab={tab} />),
  { path: 'integrations/gps/:id/devices/map', element: <GpsIntegrationPage tab="devices" sheet="map" /> },
  { path: 'integrations/add', element: <MovedAddIntegrationRedirect /> },
  { path: 'integrations/catalogue', element: <Navigate to={addIntegrationPath('sms')} replace /> },
  { path: 'integrations/installed', element: <Navigate to={integrationTabPath('gps')} replace /> },
  { path: 'integrations/installed/new', element: <Navigate to={addIntegrationPath('gps')} replace /> },
  { path: 'integrations/installed/:id', element: <MovedGpsIntegrationRedirect /> },
  { path: 'integrations/device-mappings', element: <Navigate to={integrationTabPath('gps')} replace /> },
  { path: 'integrations/device-mappings/new', element: <Navigate to={integrationTabPath('gps')} replace /> },
];
